import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import * as PageQL from "queries/page";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Edit</BreadcrumbItem>
  </>
);

export const Content = ({
  history,
  match: {
    params: {  pageId },
  },
}) => {
  const { base } = useSectionContext();

  return (
    <Mutation
      target={{ $ref: "/Public/Page/Update" }}
      mutation={PageQL.edit}
      update={PageQL.update({ pageId })}
      onMutate={({ handler, state: { values } }) => {
        handler({ variables: { pageId, input: values } });
      }}
      onCompleted={() => {
        history.replace(base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: {
      "/Public/Page/Update": {
        fields: ["title", "slug", "body"],
      },
    },
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Edit</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
